import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import HeadComponent from '../../HeadComponent';
import FaqThemeComponent from './FaqThemeComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { withLoadingCondition } from '../../loading/withLoadingCondition';

import './FaqThemeComponent.scss';

const parseHashIdfromQuery = hash => {
    const number = Number(hash.slice(1));
    return number && !isNaN(number) ? number : null;
};

export class FaqPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    componentWillMount() {
        document.body.classList.add('fullHeight');
    }

    componentWillUnmount() {
        document.body.classList.remove('fullHeight');
    }

    renderFaqs = () => {
        const { data, location } = this.props;
        if (data) {
            return data.map(theme => {
                return (
                    theme.faqs && (
                        <FaqThemeComponent
                            key={theme.id}
                            theme={theme}
                            hashId={parseHashIdfromQuery(location.hash)}
                        />
                    )
                );
            });
        }
    };

    render() {
        const { i18n, loading = false } = this.props;

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-faq">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.FAQ_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.FAQ_PATH
                        }
                    ]}
                />
                <h1>{i18n.PAGE_TITLE}</h1>
                {withLoadingCondition(loading, this.renderFaqs)}
            </main>
        );
    }
}

FaqPage.propTypes = {
    i18n: PropTypes.object.isRequired,
    data: PropTypes.array,
    loading: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.FAQ,
        data: state.faq.faqs || [],
        loading: state.faq.fetching
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(connect(mapStateToProps, mapDispatchToProps)(FaqPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqPage.js